import { IconSpriteTimes } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { FormPropertyShareInputFieldInterface } from 'common/module/form/property-share/input-field.interface';
import { FormPropertyShareTemplatePropsInterface } from 'common/module/form/property-share/template-props.interface';
import { GoogleRecaptchaTemplate } from 'common/module/google/recaptcha/template';

export const FormPropertyShareTemplate: FunctionalComponent<FormPropertyShareTemplatePropsInterface> = (props) => {
  /**
   * Render specific error message
   */
  function renderError(input: FormPropertyShareInputFieldInterface): preact.JSX.Element {
    if (input && input.error) {
      return <div className='input__message input__message--invalid'>{input.error}</div>;
    }
  }

  return (
    <div className='contact-form contact-form__share-property'>
      <div className='modal_closebutton' onClick={props.onClickClose}>
        <IconSpriteTimes />
      </div>
      <div className='contact-form__header'>
        <div className='contact-form__heading'>{i18nTranslate('Share property')}</div>
      </div>

      {props.status.submitted && (
        <div className='success-message'>
          <span
            className='svg'
            dangerouslySetInnerHTML={{
              __html: `
            <svg viewBox='0 0 32 32' class='success-message__icon'>
              <use xlink:href='#svg-success-icon'></use>
            </svg>
          `,
            }}
          />
          <div className='success-message__text'>
            <span>{i18nTranslate('Thank you')}</span>
            <span>{i18nTranslate('Your message is on its way')}</span>
          </div>
        </div>
      )}

      {!props.status.submitted && (
        <form onSubmit={props.onSubmit} className='contact-form__form contact-form__form--big'>
          <div className='contact-form__input-container contact-form__text-area'>
            <textarea
              className={`input contact-form__area ${props.input.message.error ? 'input--invalid' : ''}`}
              onChange={(e: Event) => {
                props.onChange(e, 'message');
              }}
              onBlur={(e: Event) => {
                props.onBlur(e, 'message');
              }}
              value={props.input.message.value}
            />
            {renderError(props.input.message)}
          </div>
          <div className='contact-form__user-info'>
            <div className='contact-form__input-container contact-form__name'>
              <input
                className={`input ${props.input.email.error ? ' input--invalid' : ''}`}
                placeholder={props.input.email.placeholder}
                value={props.input.email.value}
                onChange={(e: Event) => {
                  props.onChange(e, 'email');
                }}
                onBlur={(e: Event) => {
                  props.onBlur(e, 'email');
                }}
              />
              {renderError(props.input.email)}
            </div>
            <div className='contact-form__input-container contact-form__email'>
              <input
                className={`input ${props.input.friendEmail.error ? ' input--invalid' : ''}`}
                placeholder={props.input.friendEmail.placeholder}
                value={props.input.friendEmail.value}
                onChange={(e: Event) => {
                  props.onChange(e, 'friendEmail');
                }}
                onBlur={(e: Event) => {
                  props.onBlur(e, 'friendEmail');
                }}
              />
              {renderError(props.input.friendEmail)}
            </div>
          </div>
          {props.captchaRequired && (
            <div className='contact-form__input-container contact-form__captcha'>
              <GoogleRecaptchaTemplate {...props.captcha} />
              {renderError(props.input.captcha)}
            </div>
          )}

          {!!props.error && <div className='contact-form__error--general'>{props.error}</div>}

          <div className='contact-form__button-area'>
            <div />
            <div className='contact-form__button'>
              <button className={`button button--size3`} type='submit' value='Submit'>
                <div className={`button__text ${props.status.submitting ? 'button__content--hidden' : ''}`}>
                  {i18nTranslate('Send')}
                </div>
                <div className={`button__loader ${props.status.submitting ? '' : 'button__content--hidden'}`}>
                  <div className='loader2' />
                </div>
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};
